import { useVendor } from "../../hook/partner/vendor.partner.hook";
import { useAuthStore } from "../../store/auth.store";
import { useVendorsStore } from "../../store/vendors.store";
import { useEffect } from "react";
import PersonDetail from "../../components/Person/PersonDetail";

export default function MarketingTeam() {
  const vendorId = 92; // Exclusive Networks - používá se pro marketing
  const vendorMutation = useVendor();

  const token = useAuthStore((state) => state.token);
  const vendor = useVendorsStore((state) => state.vendor);

  useEffect(() => {
    if (token && vendorId) {
      vendorMutation.mutate({ token, vendorId });
    }
  }, [token, vendorId]);

  return (
    <>
      {vendor?.manager && <PersonDetail person={vendor.manager} />}

      {vendor?.marketing?.length > 0 && (
        <>
          <div className="row mt-4">
            {vendor.marketing.map((guarantor, guarantor_key) => (
              <div key={guarantor_key} className={"col-6 mb-4"}>
                <PersonDetail person={guarantor} />
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
}
